import { Dialog, DialogContent } from '@ui/dialog.tsx';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@ui/skeleton.tsx';
import type { FC } from 'react';
import { useApiBoostersIdGet } from '@r/api/generated/client.ts';
import { useOrvalQueryErrorToast } from '@r/hooks/use-orval-error-toast.ts';
import { EditBoosterDialogContent } from './edit-booster-dialog-content.tsx';

interface EditBoosterDialogProps {
  boosterId: number | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
}

/** Modale d'édition d'un booster avec champs verrouillés après le début. */
export const EditBoosterDialog: FC<EditBoosterDialogProps> = ({
  boosterId,
  isOpen,
  onOpenChange,
  onSuccess
}) => {
  const { t } = useTranslation();

  const boosterDetailQuery = useApiBoostersIdGet(String(boosterId ?? ''), {
    query: { enabled: isOpen && boosterId != null }
  });
  useOrvalQueryErrorToast(boosterDetailQuery, t('toast.error.label'));

  const booster = boosterDetailQuery.data;

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-6xl overflow-hidden p-0"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="scrollable max-h-[90vh] overflow-y-auto p-10 sm:p-14">
          {boosterDetailQuery.isLoading && <Skeleton className="h-96 w-full rounded-xl" />}

          {!boosterDetailQuery.isLoading && booster && boosterId != null && (
            <EditBoosterDialogContent
              key={booster.id}
              booster={booster}
              boosterId={boosterId}
              onClose={() => onOpenChange(false)}
              onSuccess={onSuccess}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
